import React from 'react'
import {  Modal } from 'antd'

const ViewTicket = ({ open, setOpen, record }) => {
  



  return (
    <Modal
      className='customModal'
      open={open}
      title={`Ticket Details`}
      onCancel={() => setOpen(false)}
      footer={false}
    >

      <div className=' mb-3'>
        <h6 className='text-black'>Description :</h6>
        <p className='text-black'>
          {record.description}
        </p>
      </div>
      <div className=' mb-3'>
        <h6 className='text-black'>Feedback :</h6>
        <p className='text-black'>
          {record.feedback}
        </p>
      </div>
    </Modal>
  )
}

export default ViewTicket
